import { useState } from 'react';
import { rollFormula, type RollResult } from '@gm-binder/shared';
import { Button, Input } from './index';
import styles from './DiceRoller.module.css';

const DICE = [4, 6, 8, 10, 12, 20, 100];

interface LoggedRoll extends RollResult {
  id: string;
  formula: string;
}

export interface DiceRollerProps {
  /** Optional limit on history length. */
  maxHistory?: number;
}

/** Standalone dice roller: quick dice buttons + custom formula, with a roll log. */
export function DiceRoller({ maxHistory = 30 }: DiceRollerProps) {
  const [formula, setFormula] = useState('');
  const [log, setLog] = useState<LoggedRoll[]>([]);

  const roll = (f: string) => {
    const trimmed = f.trim();
    if (!trimmed) return;
    const result = rollFormula(trimmed);
    setLog((prev) =>
      [{ ...result, id: Math.random().toString(36).slice(2), formula: trimmed }, ...prev].slice(
        0,
        maxHistory,
      ),
    );
  };

  return (
    <div>
      <div className={styles.grid}>
        {DICE.map((d) => (
          <button key={d} className={styles.die} onClick={() => roll(`1d${d}`)}>
            d{d}
          </button>
        ))}
      </div>
      <div className={styles.custom}>
        <Input
          value={formula}
          onChange={(e) => setFormula(e.target.value)}
          placeholder="Formula, es. 2d6+3"
          onKeyDown={(e) => {
            if (e.key === 'Enter') roll(formula);
          }}
          aria-label="Formula dadi"
        />
        <Button variant="primary" onClick={() => roll(formula)}>
          Tira
        </Button>
      </div>
      <div className={styles.results}>
        {log.length === 0 ? (
          <div className={styles.empty}>Nessun tiro ancora.</div>
        ) : (
          log.map((r) => (
            <div key={r.id} className={styles.roll}>
              <span className={styles.total}>{r.total}</span>
              <span className={styles.detail}>
                {r.formula} → {r.breakdown}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
